"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addColumnPrefix = void 0;
function addColumnPrefix(columns, prefix) {
    return columns.map((column) => ({
        ...column,
        datakey: `${prefix}.${column.datakey}`,
        sortkey: column.sortkey ? `${prefix}.${column.sortkey}` : undefined,
        filterkey: column.filterkey
            ? `${prefix}.${column.filterkey}`
            : undefined,
    }));
}
exports.addColumnPrefix = addColumnPrefix;
//# sourceMappingURL=table-utils.js.map